import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Query } from '@apollo/client/react/components';
import { fromGlobalId } from 'graphql-relay';
import ImageView from 'lib/images/image-view';

import Styled from 'styled';

import query, { RelatedGroupsQuery } from './related-groups.graphql';
import defaultStyles from './related-groups.scss';

export interface Props {
    id?: string;
    styles: typeof defaultStyles;
}

class RelatedGroups extends React.PureComponent<Props> {
    render() {
        const { styles } = this.props;
        return (
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    <FormattedMessage id='RELATED_GROUPS' />
                </div>
                <Query<RelatedGroupsQuery> query={query}>
                    {({ data }) =>
                        data && data.relatedGroups && data.relatedGroups.edges
                            ? data.relatedGroups.edges.map(edge => {
                                  return edge && edge.node ? (
                                      <div className={styles.group}>
                                          <Link to={`/group/${fromGlobalId(edge.node.id).id}`} className={styles.link}>
                                              <div className={styles.coverImage}>
                                                  <ImageView
                                                      sizes={{ xs: 120 }}
                                                      src={edge.node.coverPhoto && edge.node.coverPhoto.src}
                                                      srcSet={edge.node.coverPhoto && edge.node.coverPhoto.srcset}
                                                      aspectFill={true}
                                                  />
                                              </div>
                                              <div className={styles.name}>
                                                  <span>{edge.node.name}</span>
                                                  <span className={styles.membersCount}>
                                                      (
                                                      <FormattedMessage
                                                          id='FORUM_%(num)s_PRIVATE_THREAD_MEMBERS'
                                                          values={{ num: edge.node.membersCount }}
                                                      />
                                                      )
                                                  </span>
                                              </div>
                                          </Link>
                                      </div>
                                  ) : null;
                              })
                            : null
                    }
                </Query>
            </div>
        );
    }
}

export default Styled(defaultStyles)(RelatedGroups);
